import { FC, useEffect, useLayoutEffect, useRef, useState } from "react";
import { HorizontalStack } from "../../../components/Stack";
import { FontSizes, Stack, Text, mergeStyles } from "@fluentui/react";
import { ViewAll } from "../../../components/ViewAll";
import { ProjectDocumentCard } from "../../../components/Cards/ProjectDocumentCard";
import { colorPallete } from "../../../assets/color";
import { motion } from "framer-motion";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/Loader";
import { Document } from "../../../models";
import { getDocumentversions } from "../../../modules/redux/Documents/document";
import { getProjectDocuments } from "../../../modules/redux/Documents/document";
import { useParams } from "react-router-dom";
import { VersionsInDoc } from "../VersionsInDoc";
import SearchIcon from "../../../assets/Icons/svg/searchIcon";
import ListIcon from "../../../assets/Icons/svg/listIcon";
import BoxIcon from "../../../assets/Icons/svg/boxIcon";
import DocumentListView from "./docsListView";
import useModal from "../../../hooks/useModal";
import useRefreshOnReturn from "../../../hooks/useRefreshOnReturn";
import DeleteDocumentModal from "../../../components/modals/DeleteDocument";
import ReactPaginate from "react-paginate";
import "./index.css";
import { getSortedMRU } from "../../../utils";
import NextArrow from "../../../assets/Icons/svg/nextArrow";
import PrevArrow from "../../../assets/Icons/svg/prevArrow";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
const textStyles = mergeStyles({
  fontSize: FontSizes.size24,
});
const styles = {
  documentContainer: {
    width: "97%",
    height: "100%",
    alignItems: "center",
    overflowX: "hidden",
    backgroundColor: "",
    marginTop: "1.8%",
    alignSelf: "center",
    paddingBottom: "10px",
  },
  expandedDocumentContainer: {
    width: "95%",
    height: "auto",
    alignItems: "flex-start",
    marginRight: "1%",
    paddingBottom: "1%",
    marginLeft: "1.5%",
    marginTop: "1%",
    flexWrap: "wrap",
    display: "flex",
    backgroundColor: "",
  },
  loaderStyles: {
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  headerStyle: {
    fontSize: "18px",
    color: colorPallete.black,
    fontWeight: 500,
    paddingLeft: "0.6%",
    fontFamily: "Poppins",
  },
  errorStyles: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "18rem",
    alignItems: "center",
  },
  ScrollStyles: {
    height: "100%",
    alignItems: "center",
    backgroundColor: "",
    justifyContent: "center",
    zIndex: 2,
    marginLeft: "5px",
  },
  outerStack: {
    display: "flex",
    width: "99%",
    alignItems: "center",
    backgroundColor: "",
  },
  listView: {
    border: `2px solid ${colorPallete.btLightBlue}`,
    borderRadius: "0.3rem",
    cursor: "pointer",
    padding: "10px 8px 10px 8px",
    alignItems: "center",
    height: "36px",
    width: "36.049px",
    justifyContent: "center",
  },
  boxView: {
    border: `2px solid ${colorPallete.btLightBlue}`,
    borderRadius: "0.3rem",
    cursor: "pointer",
    padding: "7px",
    alignItems: "center",
    height: "36px",
    width: "36.049px",
    justifyContent: "center",
  },
};

const SearchComp = (props: any) => {
  const { t } = useTranslation();
  return (
    <HorizontalStack className="SearchComp">
      <HorizontalStack className="searchContainer">
        <SearchIcon />
        <input
          style={{
            width: "300px",
            height: "18px",
            fontFamily: "Poppins",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "16px",
          }}
          onChange={(e) => props.setSearchText(e.target.value)}
          value={props.searchText}
          // onChange={(e)=>setSearchText(e.target.value)}
          placeholder={String(t("search_project_docs"))}
          // disabled
        />
      </HorizontalStack>
      <Stack
        style={{
          backgroundColor: props.listView ? colorPallete.btLightBlue : "white",
          ...styles.listView,
        }}
        title={String(t("list_view"))}
        onClick={() => {
          props.setListView(!props.listView);
        }}
      >
        <ListIcon />
      </Stack>
      <Stack
        style={{
          backgroundColor: !props.listView ? colorPallete.btLightBlue : "white",
          ...styles.boxView,
        }}
        onClick={() => {
          props.setListView(!props.listView);
        }}
        title={String(t("box"))}
      >
        <BoxIcon />
      </Stack>
    </HorizontalStack>
  );
};
const EmptyDataJSX = () => {
  const { t } = useTranslation();
  return (
    <Stack className={mergeStyles(styles.errorStyles)}>
      <Text className={textStyles}>{t("no_document_found")}</Text>
    </Stack>
  );
};
const LoaderJSX = () => {
  return (
    <Stack className={mergeStyles(styles.loaderStyles)}>
      <Loader />
    </Stack>
  );
};

const PlaceholderDocCard = ({ fileName }: { fileName: string }) => {
  const baseName = fileName.replace(/\.[^/.]+$/, "");
  return (
    <div style={{ padding: "0 10px", boxSizing: "border-box" }}>
      <div
        style={{
          marginTop: "0.5rem",
          marginLeft: "0.5rem",
          marginRight: "8px",
          marginBottom: "15px",
          border: "4px solid transparent",
          boxSizing: "border-box",
          width: "fit-content",
          height: "fit-content",
          flexShrink: 0,
        }}
      >
        {/* Matches styles.DocCard exactly */}
        <div
          style={{
            height: "300px",
            minWidth: "200px",
            boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, .25)",
            aspectRatio: "21/29",
            flexShrink: 0,
            position: "relative",
            background: "#dce3f0",
          }}
        >
          {/* Loader fills the area below the DocCover (104px) */}
          <div
            style={{
              position: "absolute",
              top: "104px",
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader />
          </div>

          {/* Matches styles.DocCover exactly — position absolute, top-left, same as the real card */}
          <div
            style={{
              height: "104px",
              aspectRatio: "9/5",
              background: colorPallete.btLightBlue,
              boxShadow: "0px 4px 6px rgb(0 0 0 / 25%)",
              zIndex: 1,
              padding: "4%",
              minWidth: "190px",
              position: "absolute",
            }}
          >
            <Text
              style={{
                fontSize: "16px",
                paddingLeft: "1%",
                color: colorPallete.black,
                lineHeight: "20px",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "85%",
                fontFamily: "Poppins",
                fontWeight: 400,
              }}
            >
              {baseName}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

const DocBox = ({
  doc,
  showImportModal,
  setRootDocumentId,
  selectedId,
  handleFilePath,
  setSelectedId,
  setSelectedDocument,
  showModal,
  setDeleteDocName,
  setDeleteRootDocId,
  onHistoryClick,
  screenWidth,
  documentVersions,
}: {
  doc: Document;
  showImportModal?: () => void;
  setRootDocumentId?: React.Dispatch<React.SetStateAction<number>>;
  selectedId: number | undefined;
  handleFilePath: (arg0: number) => void;
  setSelectedId: React.Dispatch<React.SetStateAction<number | undefined>>;
  setSelectedDocument: React.Dispatch<React.SetStateAction<string>>;
  showModal: () => void;
  setDeleteDocName: React.Dispatch<React.SetStateAction<string>>;
  setDeleteRootDocId: React.Dispatch<React.SetStateAction<number>>;
  onHistoryClick?: () => void;
  screenWidth: number;
  documentVersions: any;
}) => {
  const [hoverId, setHoverId] = useState<number | undefined>(0);
  return (
    <motion.div
      animate={{
        opacity: 1,
        transition: {
          duration: 0.2,
          ease: "easeInOut",
        },
        scale:
          hoverId === doc.rootDocumentId || selectedId === doc.rootDocumentId
            ? 1.05
            : 1,
      }}
      initial={{
        opacity: 0,
      }}
      style={{
        marginTop: "0.5rem",
        border: selectedId === doc.rootDocumentId ? "4px solid #007CFF" : "4px solid transparent",
        boxSizing: "border-box",
        backgroundColor: "",
        marginLeft: "0.5rem",
        marginRight: "8px",
        marginBottom: "15px",
        width: "fit-content",
        height: "fit-content",
        justifySelf: screenWidth < 790 ? "center" : undefined,
        flexShrink: 0, // Prevent flex shrinking
      }}
      onMouseEnter={() => setHoverId(doc.rootDocumentId)}
      onMouseLeave={() => {
        setHoverId(0);
      }}
      onClick={() => {
        handleFilePath(doc.rootDocumentId);
        setSelectedId(doc.rootDocumentId);
        setSelectedDocument(doc.rootDocumentName);
      }}
      key={doc.documentId}
    >
      <ProjectDocumentCard
        document={doc}
        showModal={showModal}
        deleteDocName={setDeleteDocName}
        deleteRootDocId={setDeleteRootDocId}
        showImportModal={showImportModal}
        selectedId={selectedId}
        setRootDocumentId={setRootDocumentId}
        onHistoryClick={onHistoryClick}
        documentVersions={documentVersions}
      />
    </motion.div>
  );
};

export const DocsInProject: FC<any> = (props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [view, setView] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | undefined>(0);
  const [selectedDocument, setSelectedDocument] = useState("");

  const [rootDocumentId, setRootDocumentId] = useState<number>(0);
  const [versionError, setVersionError] = useState<boolean>(false);
  const [listView, setListView] = useState<boolean>(false);
  const { isModalOpen, showModal, hideModal } = useModal();
  const [deleteRootDocId, setDeleteRootDocId] = useState<number>(0);
  const [deleteDocName, setDeleteDocName] = useState<string>("");
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [rightArrowVisible, setRightArrowVisible] = useState<boolean>(false);
  const [leftArrowVisible, setLeftArrowVisible] = useState<boolean>(false);
  const [left, setLeft] = useState<number>(0);
  const [documents, setDocuments] = useState<any>([]);
  const [documentWithVersions, setDocumentWithVersions] = useState<any>([]);
  const [placeholderDocs, setPlaceholderDocs] = useState<string[]>([]);
  // DEX-573 M2: true from the moment the selected project changes until the new
  // project's documents land in the store. Gates the loader so the previous
  // project's rows never paint during the switch (navigation.feature @m2).
  const [isSwitchingProject, setIsSwitchingProject] = useState(false);
  const prevProjectIdRef = useRef<number | undefined>(props.projectData?.id);
  const awaitingRefreshRef = useRef(false);
  const pageSize = 15;
  const [currentPage, setCurrentPage] = useState(0);
  const { data: documentVersions } = useAppSelector(
    (state) => state.fetchDocumentVersion
  );
  const projectState = useAppSelector(
    (state: { fetchProjectDetails: any }) => state.fetchProjectDetails
  );
  const projectDocuments = useAppSelector(
    (state: { fetchProjectDocuments: any }) => state.fetchProjectDocuments
  );
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(5);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  
  const totalSlides = documents.length;
  const showPrevArrow = currentSlide > 0;
  const showNextArrow = currentSlide < totalSlides - slidesToShow;

  useEffect(() => {
    const calculateSlidesToShow = () => {
      try {
        const windowWidth = window.innerWidth;
        setScreenWidth(windowWidth);
        if (windowWidth < 550) {
          setSlidesToShow(1);
        } else if (windowWidth < 790) {
          setSlidesToShow(2);
        } else if (windowWidth < 1027) {
          setSlidesToShow(3);
        } else if (windowWidth < 1280) {
          setSlidesToShow(4);
        } else {
          setSlidesToShow(5);
        }
      } catch (error) {
        console.error('Error calculating slides to show:', error);
      }
    };

    calculateSlidesToShow();    
    window.addEventListener('resize', calculateSlidesToShow);
    return () => window.removeEventListener('resize', calculateSlidesToShow);
  }, []);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    afterChange: (index: number) => setCurrentSlide(index),
    prevArrow: showPrevArrow ? <PrevArrow className="prevArrow" /> : undefined,
    nextArrow: showNextArrow ? <NextArrow className="nextArrow" /> : undefined,
  };

  const bottomRef = useRef<HTMLDivElement>(null);
  const [scrollToBottom, setScrollToBottom] = useState(false);

  const handleHistoryClick = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    if (scrollToBottom && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
      setScrollToBottom(false);
    }
  }, [scrollToBottom]);

  useEffect(() => {
    if (documentVersions && documentVersions.length > 0) {
      setDocumentWithVersions(documentVersions);
    }
  }, [documentVersions]);

  useEffect(() => {
    if (versionError) {
      handleFilePath(rootDocumentId);
    }
  }, [versionError]);

  const handlePageClick = (data: any) => {
    setCurrentPage(data.selected);
  };

  useEffect(() => {
    const data = projectDocuments.data;
    // DEX-573: the fetchProjectDocuments slice is shared, so on a project switch it briefly
    // still holds the PREVIOUS project's documents. Consuming that stale data here auto-selects
    // a wrong-project document (and fetches its versions) before this project's /root lands,
    // and would clear the switch gate off stale data. Ignore data that belongs to another
    // project — its rows carry their projectId on latestVersion (M3); fall back if absent.
    const dataProjectId =
      Array.isArray(data) && data.length > 0
        ? data[0]?.projectId ?? data[0]?.latestVersion?.projectId
        : undefined;
    const dataIsForAnotherProject =
      props.projectData?.id != null &&
      dataProjectId != null &&
      dataProjectId !== props.projectData.id;
    if (dataIsForAnotherProject) return; // wait for this project's documents

    if (Array.isArray(data) && data.length > 0) {
      let documentsToSet = data;

      if (debouncedSearchText?.length) {
        documentsToSet = documentsToSet.filter((doc: any) =>
          doc?.rootDocumentName
            .split(".docx")[0]
            .split(".doc")[0]
            .toLowerCase()
            .includes(debouncedSearchText.toLowerCase())
        );
      } else {
        documentsToSet = getSortedMRU(documentsToSet);
      }

      setDocuments(documentsToSet);
    } else {
      setDocuments([]);
    }
    // The store now reflects the current project's documents — lift the switch gate.
    setIsSwitchingProject(false);
  }, [debouncedSearchText, projectDocuments.data, props.projectData?.id]);

  useEffect(() => {
    if (documents.length > 0) {
      // DEX-573: `documents` settles in two steps — first from the shared slice's existing
      // data, then again when this mount's /root refetch lands. Re-selecting the first doc
      // on the second pass re-fetched the same document's versions. Only (re)select when the
      // current selection is no longer valid for the list, so versions are fetched once.
      const selectionStillValid =
        !!selectedId &&
        documents.some((doc: Document) => doc?.rootDocumentId === selectedId);
      if (selectionStillValid) return;
      setSelectedId(documents[0]?.rootDocumentId);
      setSelectedDocument(documents[0]?.rootDocumentName);
      handleFilePath(documents[0]?.rootDocumentId);
    } else {
      setSelectedId(0);
      setSelectedDocument("");
    }
  }, [documents]);

  async function handleFilePath(rootDocumentId: number) {
    setRootDocumentId(rootDocumentId);
    if (rootDocumentId && rootDocumentId !== 0) {
      const result = await dispatch(
        getDocumentversions({ rootDocumentId })
      ).unwrap();
    }
  }
  // DEX-573 M2: when the selected project changes, drop the previous project's
  // documents and selection *before paint* (useLayoutEffect runs before the browser
  // paints), and raise the switch gate so the loader — not project A's stale rows —
  // shows until project B's data arrives. Runs on switch only, not on mount.
  useLayoutEffect(() => {
    const nextId = props.projectData?.id;
    if (nextId === prevProjectIdRef.current) return;
    prevProjectIdRef.current = nextId;
    setIsSwitchingProject(true);
    setDocuments([]);
    setDocumentWithVersions([]);
    setPlaceholderDocs([]);
    setSelectedId(0);
    setSelectedDocument("");
  }, [props.projectData?.id]);

  useEffect(() => {
    if (props.projectData?.id) {
      dispatch(getProjectDocuments(props.projectData.id));
    }
  }, [props.projectData?.id, dispatch]);

  useRefreshOnReturn(
    () => {
      const projectId = props.projectData?.id;
      if (projectId) {
        dispatch(getProjectDocuments({ projectId, silent: true }));
      }
      if (selectedId) {
        dispatch(getDocumentversions({ rootDocumentId: selectedId, silent: true }));
      }
    },
    { enabled: !!props.projectData?.id }
  );

  useEffect(() => {
    if (!props.uploadedFileNames?.length) return;
    setPlaceholderDocs(props.uploadedFileNames);
    awaitingRefreshRef.current = true;
    if (props.projectData?.id) {
      dispatch(getProjectDocuments(props.projectData.id));
    }
  }, [props.uploadedFileNames]);

  useEffect(() => {
    if (!props.uploadedVersionRootDocIds?.length) return;
    if (props.projectData?.id) {
      dispatch(getProjectDocuments(props.projectData.id));
    }
    props.onVersionUploadHandled?.();
  }, [props.uploadedVersionRootDocIds]);

  useEffect(() => {
    if (!awaitingRefreshRef.current || !projectDocuments.data?.length || placeholderDocs.length === 0) return;
    awaitingRefreshRef.current = false;

    const normalize = (name: string) => name.replace(/\.[^/.]+$/, "").toLowerCase().trim();
    const pendingNames = new Set(placeholderDocs.map(normalize));

    const newDocs = projectDocuments.data.filter((doc: any) =>
      pendingNames.has(normalize(doc.rootDocumentName || ""))
    );

    setPlaceholderDocs((prev) => {
      const matched = new Set(newDocs.map((d: any) => normalize(d.rootDocumentName || "")));
      return prev.filter((name) => !matched.has(normalize(name)));
    });

    if (newDocs.length > 0) {
      const first = newDocs[0];
      setSelectedId(first.rootDocumentId);
      setSelectedDocument(first.rootDocumentName);
      handleFilePath(first.rootDocumentId);
    }

    props.onUploadHandled?.();
  }, [projectDocuments.data]);

  const Buttons = ({ documents }: any) => {
    let distance = left;
    const element = document.getElementById("myStack");
    useEffect(() => {
      if (left && element) {
        element.scrollLeft += left;
      }
    }, [left, element]);

    useEffect(() => {
      if (props.left && element) {
        element.scrollLeft += props.left;
      }

      if (element) {
        const isAtStart = element.scrollLeft === 0;
        const isAtEnd =
          element.scrollLeft + element.clientWidth === element.scrollWidth;

        setLeftArrowVisible(!isAtStart);
        setRightArrowVisible(!isAtEnd);
      }
    }, [left, documents]);
    return (
      <>
        {leftArrowVisible && (
          <Stack
            style={{
              ...styles.ScrollStyles,
              alignSelf: "flex-start",
              position: "absolute",
            }}
            onClick={() => {
              if (left > 0) {
                let a = 0;
                setLeft((a -= 680));
              } else {
                setLeft((distance -= 400));
              }
            }}
          >
            {documents && documents.length !== 0 && (
              <img
                src={require("../../../assets/Icons/LeftScroll.png")}
                style={{ cursor: "pointer" }}
                alt=""
              />
            )}
          </Stack>
        )}
        {rightArrowVisible && (
          <Stack
            style={{
              ...styles.ScrollStyles,
              alignSelf: "flex-end",
              position: "absolute",
              right: 8,
            }}
            onClick={() => {
              if (left < 0) {
                let a = 0;
                setLeft((a += 680));
              } else {
                setLeft((distance += 400));
              }
            }}
          >
            {documents && documents.length !== 0 && (
              <img
                src={require("../../../assets/Icons/RightScroll.png")}
                style={{ cursor: "pointer" }}
                alt=""
              />
            )}
          </Stack>
        )}
      </>
    );
  };

  return (
    <>
      <div style={{ backgroundColor: "" }}>
        <HorizontalStack className="HeaderStack">
          <HorizontalStack className="HeaderStackContentProjects" >
            <Text style={styles.headerStyle}>{t("existing_proj_docs")}</Text>
            {!listView && <ViewAll
              onClickFunction={() => {
                setView(!view);
              }}
              collapsed={view}
            />}
          </HorizontalStack>
          <SearchComp
            searchText={searchText}
            setSearchText={setSearchText}
            listView={listView}
            setListView={setListView}
          />
        </HorizontalStack>
        <Stack
          style={{
            ...styles.outerStack,
            position: "relative",
            justifyContent: "flex-start",
            minHeight: "20rem",
            alignItems: "center",
          }}
        >
          {!view ? (
            <>
              {(projectDocuments.isLoading || isSwitchingProject) &&
              placeholderDocs.length === 0 ? (
                <LoaderJSX />
              ) : documents.length === 0 && placeholderDocs.length === 0 ? (
                <EmptyDataJSX />
              ) : documents && !listView ? (
                <>
                  <HorizontalStack
                    className={mergeStyles(styles.documentContainer)}
                    id="myStack"
                    style={{position: "relative", display: "block", overflow: "visible"}}
                  >
                    <Slider {...settings}>
                      {placeholderDocs.map((name) => (
                        <PlaceholderDocCard key={`placeholder-${name}`} fileName={name} />
                      ))}
                      {documents
                        .filter((doc: Document) => doc?.rootDocumentId)
                        .map((doc: Document, index: number) => (
                          <div
                            key={doc.rootDocumentId || (doc as any).id || index}
                            style={{
                              padding: "0 10px",
                              boxSizing: "border-box",
                            }}
                          >
                            <DocBox
                              doc={doc}
                              showImportModal={props?.showImportModal}
                              setRootDocumentId={props?.setRootDocumentId}
                              selectedId={selectedId}
                              handleFilePath={handleFilePath}
                              setDeleteDocName={setDeleteDocName}
                              setDeleteRootDocId={setDeleteRootDocId}
                              setSelectedDocument={setSelectedDocument}
                              setSelectedId={setSelectedId}
                              showModal={showModal}
                              onHistoryClick={handleHistoryClick}
                              screenWidth={screenWidth}
                              documentVersions={documentVersions}
                            />
                          </div>
                        ))}
                    </Slider>

                  </HorizontalStack>
                </>
              ) : (
                <DocumentListView
                  data={documents}
                  listView={view}
                  handleFilePath={handleFilePath}
                  setSelectedDocument={setSelectedDocument}
                  selectedId={selectedId}
                  setSelectedId={setSelectedId}
                  showModal={showModal}
                  deleteDocName={setDeleteDocName}
                  deleteRootDocId={setDeleteRootDocId}
                />
              )}
            </>
          ) : (
            <>
              {projectDocuments.isLoading || isSwitchingProject ? (
                <LoaderJSX />
              ) : documents.length === 0 ? (
                <EmptyDataJSX />
              ) : documents && documents.length !== 0 && !listView ? (
                <div
                  className="container"
                  style={{ backgroundColor: "inherit" }}
                >
                  <div className="stack">
                    {documents
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((doc: Document, index: number) => {
                        return (
                          <DocBox
                            key={doc.rootDocumentId || index}
                            doc={doc}
                            showImportModal={props?.showImportModal}
                            setRootDocumentId={props?.setRootDocumentId}
                            selectedId={selectedId}
                            handleFilePath={handleFilePath}
                            setDeleteDocName={setDeleteDocName}
                            setDeleteRootDocId={setDeleteRootDocId}
                            setSelectedDocument={setSelectedDocument}
                            setSelectedId={setSelectedId}
                            showModal={showModal}
                            onHistoryClick={handleHistoryClick}
                            screenWidth={screenWidth}
                            documentVersions={documentVersions}
                          />
                        );
                      })}
                  </div>
                  {documents.length > pageSize && (
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={Math.ceil(documents.length / pageSize)}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={1}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              ) : (
                <DocumentListView
                  data={documentWithVersions}
                  listView={view}
                  handleFilePath={handleFilePath}
                  setSelectedDocument={setSelectedDocument}
                  setSelectedId={setSelectedId}
                  selectedId={selectedId}
                  showModal={showModal}
                  deleteDocName={setDeleteDocName}
                  deleteRootDocId={setDeleteRootDocId}
                />
              )}
            </>
          )}
        </Stack>
      </div>
      <div ref={bottomRef}>
        <VersionsInDoc
          projectData={props.projectData}
          documents={documents}
          selectedDocument={selectedDocument}
          selectedId={selectedId}
          versionError={versionError}
          setVersionError={setVersionError}
          refresh={props.refresh}
          setScrollToBottom={setScrollToBottom}
        />
      </div>
      <DeleteDocumentModal
        isModalOpen={isModalOpen}
        showModal={showModal}
        hideModal={hideModal}
        documentName={deleteDocName}
        rootDocumentId={deleteRootDocId}
        refresh={props.refresh}
        projectId={projectState.data?.id}
      />
    </>
  );
};
